import React from "react";
import { ABOUT, SITE } from "../mock";
import { useEnquiry } from "../context/EnquiryContext";

const About = () => {
  const { open: openEnquiry } = useEnquiry();
  return (
    <section id="about" className="py-24 md:py-32 bg-[#f5efe6]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-6 reveal">
            <p className="kicker mb-6">{ABOUT.kicker}</p>
            <h2 className="font-display display-tight text-5xl md:text-6xl lg:text-7xl text-[#1f1d1a] mb-10">
              {ABOUT.heading_pre}<br/>
              <span className="italic font-light">{ABOUT.heading_post}</span>
            </h2>
            <div className="section-rule mb-8" />
            <div className="space-y-5 text-[#3a342c] text-[1.05rem] leading-[1.85] font-light max-w-xl">
              {ABOUT.body.map((p, i) => (
                <p key={i} className={i === 0 ? "font-serif italic text-[1.35rem] text-[#1f1d1a] leading-snug" : ""}>{p}</p>
              ))}
            </div>

            <p className="mt-10 text-xs tracking-[0.25em] uppercase text-[#8b6f47]">
              {ABOUT.parent_note}{" "}
              <a href={SITE.parentUrl} target="_blank" rel="noreferrer" className="underline underline-offset-4 hover:text-[#1f1d1a] transition-colors">
                {SITE.parentName}
              </a>
            </p>

            <button onClick={openEnquiry} className="btn-primary mt-8">
              Save Your Date
            </button>
          </div>

          <div className="lg:col-span-6 reveal">
            <div className="relative">
              <div className="aspect-[4/5] w-full overflow-hidden">
                <img src={ABOUT.image} alt="Real Essex wedding" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -bottom-6 -left-6 md:-bottom-10 md:-left-10 bg-[#1f1d1a] text-[#f5efe6] p-6 md:p-8 max-w-[280px]">
                <p className="font-display italic text-2xl md:text-[1.7rem] leading-tight text-[#e8dfc9]">
                  {ABOUT.pull_quote}
                </p>
                <p className="mt-3 text-[0.7rem] tracking-[0.3em] uppercase text-[#c9a87c]">{ABOUT.pull_quote_credit}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
